import React, { useState } from "react";
import * as emailjs from "emailjs-com";
import "./style.css";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin,
  FaPaperPlane,
  FaRegCommentDots,
} from "react-icons/fa";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { contactConfig, socialprofils } from "../../content_option";

const whatsappNumber = contactConfig.YOUR_FONE
  ? contactConfig.YOUR_FONE.replace(/[^\d]/g, "")
  : "";

export const ContactUs = () => {
  const [formData, setFormdata] = useState({
    email: "",
    name: "",
    message: "",
    loading: false,
    show: false,
    alertmessage: "",
    variant: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormdata((current) => ({ ...current, loading: true, show: false }));

    const templateParams = {
      from_name: formData.email,
      user_name: formData.name,
      to_name: contactConfig.YOUR_EMAIL,
      message: formData.message,
    };

    emailjs
      .send(
        contactConfig.YOUR_SERVICE_ID,
        contactConfig.YOUR_TEMPLATE_ID,
        templateParams,
        contactConfig.YOUR_USER_ID
      )
      .then(
        (result) => {
          console.log(result.text);
            setFormdata((current) => ({
            ...current,
            loading: false,
            alertmessage: "Thanks for reaching out. Your message has been sent.",
            variant: "success",
            show: true,
          }));
        },
        (error) => {
          console.log(error.text);
          setFormdata((current) => ({
            ...current,
            loading: false,
            alertmessage: `Couldn't send your message. ${error.text || "Please try again or contact me by email."}`,
            variant: "danger",
            show: true,
          }));
          document.querySelector(".co_alert")?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      );
  };

  const handleChange = (e) => {
    setFormdata({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="contact_section">
      <Container>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">Contact Me</h1>
            <hr className="t_border my-4 ml-0 text-left" />
            <p className="po_subtitle">{contactConfig.description}</p>
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="12">
            <Alert
              variant={formData.variant}
              className={`rounded-0 co_alert ${
                formData.show ? "d-block" : "d-none"
              }`}
              onClose={() => setFormdata((current) => ({ ...current, show: false }))}
              dismissible
            >
              <p className="my-0">{formData.alertmessage}</p>
            </Alert>
          </Col>

          <Col lg="5" className="mb-5">
            <div className="co_info_list">
              <a
                className="co_info_item glass"
                href={`mailto:${contactConfig.YOUR_EMAIL}`}
              >
                <span className="co_info_icon">
                  <FaEnvelope />
                </span>
                <span className="co_info_text">
                  <span className="co_info_label">Email</span>
                  <span className="co_info_value">{contactConfig.YOUR_EMAIL}</span>
                </span>
              </a>

              {contactConfig.YOUR_FONE && (
                <a
                  className="co_info_item glass"
                  href={`tel:${contactConfig.YOUR_FONE}`}
                >
                  <span className="co_info_icon">
                    <FaPhoneAlt />
                  </span>
                  <span className="co_info_text">
                    <span className="co_info_label">Phone</span>
                    <span className="co_info_value">{contactConfig.YOUR_FONE}</span>
                  </span>
                </a>
              )}

              {whatsappNumber && (
                <a
                  className="co_info_item glass"
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="co_info_icon co_info_icon-whatsapp">
                    <FaWhatsapp />
                  </span>
                  <span className="co_info_text">
                    <span className="co_info_label">WhatsApp</span>
                    <span className="co_info_value">{contactConfig.YOUR_FONE}</span>
                  </span>
                </a>
              )}

              {contactConfig.YOUR_LOCATION && (
                <div className="co_info_item glass">
                  <span className="co_info_icon">
                    <FaMapMarkerAlt />
                  </span>
                  <span className="co_info_text">
                    <span className="co_info_label">Location</span>
                    <span className="co_info_value">
                      {contactConfig.YOUR_LOCATION}
                    </span>
                  </span>
                </div>
              )}

              <div className="co_info_row">
                {socialprofils.github && (
                  <a
                    className="co_info_item glass"
                    href={socialprofils.github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="co_info_icon">
                      <FaGithub />
                    </span>
                    <span className="co_info_text">
                      <span className="co_info_label">GitHub</span>
                    </span>
                  </a>
                )}
                {socialprofils.linkedin && (
                  <a
                    className="co_info_item glass"
                    href={socialprofils.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="co_info_icon">
                      <FaLinkedin />
                    </span>
                    <span className="co_info_text">
                      <span className="co_info_label">LinkedIn</span>
                    </span>
                  </a>
                )}
              </div>
            </div>

            <div className="cv-btn">
              <a
                href="https://www.dropbox.com/scl/fi/co3y9gv1n6xk130l45txj/Hamza-Zahid-Video-Editor.pdf?rlkey=9mf8osruw7fs3rnl0voj47u7j&st=uwjfnhv2&dl=0"
                target="_blank"
                rel="noreferrer"
              >
                Download CV
              </a>
            </div>
          </Col>

          <Col lg="7">
            <div className="co_form_card glass">
              <div className="co_form_heading">
                <span className="co_form_kicker">PROJECT ENQUIRY <span aria-hidden="true">/</span> 01</span>
                <h3 className="co_form_title">Let’s make something<br className="co_title_break" /> worth watching.</h3>
                <p className="co_form_intro">Share a few details about your video and I’ll get back to you.</p>
              </div>
              <form onSubmit={handleSubmit} className="contact__form w-100">
                <div className="co_form_fields">
                  <div className="co_field">
                    <label htmlFor="name">Your name</label>
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="e.g. Alex Morgan"
                      value={formData.name || ""}
                      type="text"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="co_field">
                    <label htmlFor="email">Email address</label>
                    <input
                      className="form-control rounded-0"
                      id="email"
                      name="email"
                      placeholder="you@example.com"
                      type="email"
                      value={formData.email || ""}
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="co_field co_field--message">
                    <label htmlFor="message">Tell me about your project</label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      placeholder="What are you creating, and where will it be shared?"
                      rows="5"
                      value={formData.message || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="co_form_footer">
                  <span className="co_form_note"><FaRegCommentDots aria-hidden="true" /> No pressure—just tell me what you have in mind.</span>
                  <button className="btn ac_btn co_submit" type="submit" disabled={formData.loading}>
                    {formData.loading ? "Sending…" : "Send project details"}
                    <FaPaperPlane className="co_send_icon" aria-hidden="true" />
                  </button>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={formData.loading ? "loading-bar" : "d-none"}></div>
    </section>
  );
};
